// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"HXac3","text":"HXah","input":"HXmp"};